import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CompanyType from './icon-company-type.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CompanyType {...validProps} />;
}
SvgComponent.iconName = 'company-type';

/**
 * @deprecated This is a legacy icon
 */
export const CompanyTypeIcon = svgIconWrapper(SvgComponent);
